<script setup>
import {computed} from 'vue'
import {useThemesStore} from '@/stores/themes'

const themesStore = useThemesStore()

const activeCssGroupName = computed(() => themesStore.activeCssGroupName)
const cssGroupNames = computed(() => themesStore.cssGroupNames)
const tableName = computed(() => themesStore.tableName)
const noneGroupName = computed(() => themesStore.noneGroupName)
const allGroupName = computed(() => themesStore.allGroupName)

const show = computed(() => tableName.value === 'themes_css')

const groupNames = computed(() => {
    if (!cssGroupNames.value) return []

    return [
        allGroupName.value,
        noneGroupName.value,
        ...cssGroupNames.value
    ]
})

const setActiveCssGroupName = (groupName) => {
    themesStore.setActiveCssGroupName(groupName)
}
</script>

<template>
    <div v-if="show && cssGroupNames" class="dropdown">
        <button class="btn btn-light btn-sm dropdown-toggle" data-bs-toggle="dropdown" type="button">
            {{ activeCssGroupName }}
        </button>
        <div class="dropdown-menu">
            <button
                type="button"
                v-for="groupName in groupNames"
                :key="groupName"
                :class="{ 'active': groupName === activeCssGroupName }"
                class="dropdown-item"
                @click="setActiveCssGroupName(groupName)"
            >
                {{ groupName }}
            </button>
        </div>
    </div>
</template>